import { render } from "./APIRequest.vue?vue&type=template&id=3a8176a2"
import script from "./APIRequest.vue?vue&type=script&lang=js"
export * from "./APIRequest.vue?vue&type=script&lang=js"

import exportComponent from "/home/pzborow/works/gunb/rwdzold/dev/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__